import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { firstValueFrom } from 'rxjs';

/**
 * Inicializador para configurar ngx-translate en PrimeNG para la gestión de idioma.
 * @returns Promesa que se resuelve cuando se han cargado las traducciones.
 */
export const initializePrimeTranslation = () => {
  const primeNg = inject(PrimeNG);
  const translator = inject(TranslateService);

  return firstValueFrom(translator.use('es')).then(async () => {
    const translations = await firstValueFrom(translator.get('app.primeng'));
    primeNg.setTranslation(translations as Record<string, unknown>);
  });
};
